import { UnitSystemEnum } from '@/__generated__/graphql';
import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { unitSystem as unitSystemState } from '../../state';
import { subHeadingUnitStyles } from './styles';

export const ExportCsvSubheading = () => {
  const unitSystem = useAtomValue(unitSystemState);

  const [currentUnit, alternateUnit] = useMemo(() => {
    return unitSystem === UnitSystemEnum.Imperial ? ['imperial', 'metric'] : ['metric', 'imperial'];
  }, [unitSystem]);

  return (
    <>
      Selected columns will be exported as a .xlsx file in{' '}
      <span style={subHeadingUnitStyles}>{currentUnit} units</span>. To switch to{' '}
      <span style={subHeadingUnitStyles}>{alternateUnit} units</span>, use general settings.
    </>
  );
};
